import { render, staticRenderFns } from "./libros_evaluaciones.vue?vue&type=template&id=5fac9ee2"
import script from "./libros_evaluaciones.vue?vue&type=script&lang=js"
export * from "./libros_evaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports